
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
components: {
Group,
XInput,
XButton
},
name: "changepassword",
data() {
return {
oldpasswd: "",
newpasswdone: "",
newpasswdtwo: ""
};
},
methods: {
changepassword() {
var that = this
var account = this.$route.params.id;
var userInfo = {
passwd: this.oldpasswd,
account: account,
is_passwd: true,
tp:'mobile'
};
var newUserInfo = {
passwd: this.newpasswdtwo
}
this.$http.post("/api/v1/accounts", userInfo)
.then(function (res) {
localStorage.setItem('token', res.data.token)
localStorage.setItem('userid', res.data.userid)
var obj = {
headers: {
token: res.data.token,
opid: res.data.userid
}
}

if (that.newpasswdone !== that.newpasswdtwo) {
that.$vux.toast.show({
text: '密码不一致,请重新输入',
type: 'cancel',
time: '1000'
})
} else if (that.newpasswdone.length < 6) {
that.$vux.toast.show({
text: '密码长度不能少于6位',
type: 'cancel',
time: '1000'
})
} else {
that.$http.put("/api/v1/accounts/" + res.data.userid, newUserInfo, obj)
.then(function (res) {
that.$vux.toast.show({
text: '修改成功',
type: 'success',
time: '1000'
});
that.$router.push({path: "/"})
})
}
})
.catch(function (error) {
if (error.response) {
if (error.response.data.error_message) {
that.$vux.toast.show({
text: '原密码错误,请重新输入',
type: 'cancel',
time: '1000'
});
}
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/xgmm.vue